export const MODEL_HUB_SCREEN = 'MODEL_HUB_SCREEN';

// Layout dimensions shared between the navbar and the main content padding. Explicit px values
// intentionally bypass Mantine's rem() conversion, which is incorrect under the monolith's
// `html { font-size: 62.5% }` (10px root).
export const MODEL_HUB_NAVBAR_WIDTH_PX = 248;
export const MODEL_HUB_MAIN_PADDING_X_PX = 40;

// Vertical chrome above listing tables: main region padding (32px top + 32px bottom),
// page title + section spacing, and the search/filter toolbar. Keeps the table body
// scrollable while headers stay sticky within the paper.
export const MODEL_HUB_LISTING_TABLE_MAX_HEIGHT_OFFSET_PX = 280;
